import { useEffect, useState } from 'react';

export default function ResearchPage() {
  const [openAccordion, setOpenAccordion] = useState(false);
  const [openMethodsAccordion, setOpenMethodsAccordion] = useState(false);
  const [openServicesAccordion, setOpenServicesAccordion] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 100) {
          header.classList.add('bg-white', 'shadow-md');
        } else {
          header.classList.remove('bg-white', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="https://jaknaf.readdy.co" className="flex items-center space-x-3" data-discover="true">
              <img
                src="https://static.readdy.ai/image/a422443b07c5ef04b420db188867b9ad/ce6fd3da735f6be630e7bf30dfef3790.png"
                alt="PM Tools Logo"
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold text-gray-900">Инструменты продакта</span>
            </a>
            <nav className="hidden md:flex items-center space-x-8">
              <a href="https://jaknaf.readdy.co" className="font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-[#EE9B00] cursor-pointer">
                Главная
              </a>
              <a href="/research" className="font-medium transition-colors whitespace-nowrap text-[#EE9B00] cursor-pointer">
                Исследование
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-700 via-slate-600 to-slate-500">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-20 left-10 w-64 h-64 bg-slate-400 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-slate-500 rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/3 w-72 h-72 bg-slate-600 rounded-full blur-3xl"></div>
          </div>
          <div className="absolute inset-0" style={{
            backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px),
                             repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)`
          }}></div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 py-32 text-center">
          <div className="mb-8">
            <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium">
              Исследование 2025
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-8 leading-tight">
            Исследование: какими инструментами реально пользуются продакты
          </h1>
          <p className="text-xl lg:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
            Без хайпа, без «топ-10 must-have». Только то, что люди реально используют в работе.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-16">
            <button 
              onClick={() => document.getElementById('results')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Посмотреть результаты
            </button>
            <button 
              onClick={() => document.getElementById('results')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-transparent border-2 border-white/30 text-white rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Пролистайте ниже, там самое интересное
            </button>
          </div>

          {/* Visual Grid */}
          <div className="grid grid-cols-4 md:grid-cols-8 gap-4 max-w-4xl mx-auto opacity-60">
            {['Figma', 'Jira', 'Notion', 'Miro', 'Amplitude', 'Mixpanel', 'Slack', 'Confluence'].map((tool, idx) => (
              <div key={idx} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 flex items-center justify-center h-20">
                <span className="text-white text-xs font-medium text-center">{tool}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Context Section */}
      <section className="py-32 bg-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 right-20 w-96 h-96 bg-[#EE9B00] rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-slate-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="text-center mb-20">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-[#EE9B00] to-[#D88A00] rounded-2xl flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-question-line text-4xl text-white"></i>
              </div>
            </div>
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Зачем вообще нужно это исследование
            </h2>
            <div className="max-w-3xl mx-auto space-y-4 text-xl text-gray-600 leading-relaxed">
              <p>
                Инструментов много, времени у продакта — нет.
              </p>
              <p>
                Часто выбирают не лучшее, а «привычное». Или то, что посоветовал коллега. Или что увидели в статье на Medium.
              </p>
              <p className="font-medium text-gray-900">
                Хотелось понять: чем реально пользуются, а не что советуют в статьях с заголовками «10 must-have tools for PM».
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EE9B00] to-[#D88A00] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-stack-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Инструментов много</h3>
              <p className="text-gray-600 leading-relaxed">
                Каждый день появляются новые сервисы, фреймворки и методологии. Выбор стал проблемой сам по себе.
              </p>
            </div>

            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-slate-600 to-slate-700 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-refresh-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Часто выбирают не лучшее, а «привычное»</h3>
              <p className="text-gray-600 leading-relaxed">
                Мы используем то, что когда-то сработало. Даже если есть что-то более подходящее — переучиваться некогда.
              </p>
            </div>

            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EE9B00] to-[#D88A00] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-checkbox-circle-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Хотелось понять реальность</h3>
              <p className="text-gray-600 leading-relaxed">
                Не то, что советуют в статьях с заголовками «10 must-have tools for PM», а чем реально пользуются продакты в ежедневной работе.
              </p>
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-br from-[#EE9B00]/10 to-[#D88A00]/5 border-l-4 border-[#EE9B00] rounded-r-3xl p-10">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#EE9B00] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Главный вопрос</h4>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Какие инструменты действительно помогают решать задачи, а какие просто создают иллюзию продуктивности?
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Methodology Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
            Как мы собирали данные
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-survey-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Онлайн-опрос</h3>
                  <p className="text-gray-600">Продакт-менеджеров из разных компаний</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Разные уровни</h3>
                  <p className="text-gray-600">От junior до lead</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Разные компании</h3>
                  <p className="text-gray-600">Стартапы, корпорации, продуктовые студии</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-percent-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Проценты, не числа</h3>
                  <p className="text-gray-600">Используем относительные показатели</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-amber-50 border-l-4 border-[#EE9B00] rounded-r-2xl p-8">
            <p className="text-gray-700 text-lg leading-relaxed">
              <strong>Важно:</strong> Это не «истина в последней инстанции», а срез. Рынок меняется, инструменты эволюционируют.
            </p>
          </div>
        </div>
      </section>

      {/* Key Insight Section */}
      <section className="py-32 bg-gradient-to-br from-slate-700 to-slate-600 text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="mb-8">
            <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-sm font-medium">
              Главный вывод
            </span>
          </div>
          <h2 className="text-4xl lg:text-6xl font-bold mb-12 leading-tight">
            Главный вывод исследования
          </h2>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-12 lg:p-16">
            <p className="text-2xl lg:text-4xl font-bold leading-relaxed">
              Продакты думают не инструментами. Они мыслят задачами.
            </p>
            <p className="text-xl lg:text-2xl text-gray-200 leading-relaxed">
              Инструмент выбирают не потому, что он «правильный», а потому, что когда-то он сработал.
            </p>
          </div>
        </div>
      </section>

      {/* Портрет респондентов Section */}
      <section id="results" className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Портрет респондентов
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Кто участвовал в исследовании
          </p>

          {/* Роль в компании */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Роль в компании</h3>
            <div className="space-y-4">
              {[
                { role: 'Product Manager', percent: 41.1 },
                { role: 'Product Owner', percent: 13.1 },
                { role: 'Head of Product', percent: 8.0 },
                { role: 'CPO', percent: 6.9 },
                { role: 'Product Lead', percent: 6.3 },
                { role: 'Project Manager', percent: 6.3 },
                { role: 'Product Marketing Manager', percent: 5.7 },
                { role: 'CEO / Founder', percent: 2.9 },
                { role: 'Product Analyst', percent: 2.9 },
                { role: 'Другое', percent: 6.8 },
              ].map((item, idx) => (
                <div key={idx} className="bg-gray-50 rounded-xl p-5">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-medium text-gray-900">{item.role}</span>
                    <span className="text-2xl font-bold text-slate-600">{item.percent}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div 
                      className="bg-gradient-to-r from-slate-600 to-slate-500 h-full rounded-full transition-all duration-1000"
                      style={{ width: `${item.percent}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-4 italic">
              Основная часть ответов — от практикующих PM/PO. Управленческие и редкие роли собраны в разделе «Другое».
            </p>
          </div>

          {/* Уровень */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Уровень</h3>
            <div className="space-y-4">
              {[
                { level: 'Middle', percent: 38.3 },
                { level: 'Senior', percent: 36.6 },
                { level: 'Junior', percent: 16.0 },
                { level: 'Lead / Head / Top-manager', percent: 9.1 },
              ].map((item, idx) => (
                <div key={idx} className="bg-gray-50 rounded-xl p-5">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-medium text-gray-900">{item.level}</span>
                    <span className="text-2xl font-bold text-slate-600">{item.percent}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div 
                      className="bg-gradient-to-r from-slate-600 to-slate-500 h-full rounded-full transition-all duration-1000"
                      style={{ width: `${item.percent}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-4 italic">
              Ядро выборки — Middle и Senior, то есть люди, которые ежедневно "руками" пользуются инструментами.
            </p>
          </div>

          {/* Отрасль */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Отрасль</h3>
            <div className="space-y-4">
              {[
                { industry: 'FinTech', percent: 20.6 },
                { industry: 'E-commerce & Marketplaces', percent: 18.9 },
                { industry: 'SaaS / B2B Software', percent: 17.1 },
                { industry: 'EdTech', percent: 8.0 },
                { industry: 'HealthTech / MedTech', percent: 3.4 },
                { industry: 'Gaming & Entertainment', percent: 2.9 },
                { industry: 'Не указали', percent: 3.4 },
                { industry: 'Другое', percent: 25.7 },
              ].map((item, idx) => (
                <div key={idx} className="bg-gray-50 rounded-xl p-5">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-medium text-gray-900">{item.industry}</span>
                    <span className="text-2xl font-bold text-slate-600">{item.percent}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div 
                      className="bg-gradient-to-r from-slate-600 to-slate-500 h-full rounded-full transition-all duration-1000"
                      style={{ width: `${item.percent}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-4 italic">
              Отраслей много, "длинный хвост" большой — исследование межотраслевое.
            </p>
          </div>

          {/* Стадия развития */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Стадия развития компании / продукта</h3>
            <div className="space-y-4">
              {[
                { stage: 'Зрелая / корпоративная', percent: 38.3 },
                { stage: 'Рост (серии A–B)', percent: 26.9 },
                { stage: 'Масштабирование (серии C–D)', percent: 15.4 },
                { stage: 'Ранняя стадия (посевная)', percent: 9.7 },
                { stage: 'Идея / предпосевная', percent: 6.3 },
              ].map((item, idx) => (
                <div key={idx} className="bg-gray-50 rounded-xl p-5">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-medium text-gray-900">{item.stage}</span>
                    <span className="text-2xl font-bold text-slate-600">{item.percent}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div 
                      className="bg-gradient-to-r from-slate-600 to-slate-500 h-full rounded-full transition-all duration-1000"
                      style={{ width: `${item.percent}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-4 italic">
              Большая часть ответов — от команд, которые уже работают с запущенным продуктом и занимаются его масштабированием.
            </p>
          </div>

          {/* Мини-вывод */}
          <div className="bg-slate-50 border-l-4 border-slate-600 rounded-r-2xl p-8">
            <p className="text-gray-700 text-lg leading-relaxed">
              В выборке преобладают Middle+Senior и продукты на стадиях Growth/Mature. Это срез практики, а не «идеальный набор инструментов».
            </p>
          </div>
        </div>
      </section>

      {/* Фреймворки Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Фреймворки
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Оценка по шкале 0–3. Пустые ответы считаем как 0. Ниже — доля продактов, которые используют фреймворк (1–3), считают его очень полезным (3), и не используют (0).
          </p>

          {/* Accordion */}
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <button
              onClick={() => setOpenAccordion(!openAccordion)}
              className="w-full px-8 py-6 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <span className="text-xl font-bold text-gray-900">Все фреймворки</span>
              <i className={`ri-arrow-${openAccordion ? 'up' : 'down'}-s-line text-2xl text-gray-600 transition-transform`}></i>
            </button>
            
            {openAccordion && (
              <div className="px-8 pb-6 space-y-3">
                {[
                  { name: 'Jobs To Be Done (JTBD) / Advance JTBD', use: 70.9, veryUseful: 35.4, notUse: 29.1, rare: false },
                  { name: 'User Story Mapping', use: 65.7, veryUseful: 33.7, notUse: 34.3, rare: false },
                  { name: 'CJM (Customer Journey Map)', use: 64.0, veryUseful: 39.4, notUse: 36.0, rare: false },
                  { name: 'Customer Development (CustDev)', use: 64.0, veryUseful: 34.9, notUse: 36.0, rare: false },
                  { name: 'Kanban Methodology', use: 63.4, veryUseful: 24.6, notUse: 36.6, rare: false },
                  { name: 'A/B testing (Split-testing)', use: 60.6, veryUseful: 32.0, notUse: 39.4, rare: false },
                  { name: 'Scrum Methodology', use: 60.0, veryUseful: 25.7, notUse: 40.0, rare: false },
                  { name: 'Agile Software Development', use: 57.1, veryUseful: 27.4, notUse: 42.9, rare: false },
                  { name: 'Design Thinking (Дизайн-мышление)', use: 56.0, veryUseful: 18.9, notUse: 44.0, rare: false },
                  { name: 'OKR', use: 53.7, veryUseful: 18.3, notUse: 46.3, rare: false },
                  { name: 'Pirate Metrics (AARRR / AAARRR)', use: 48.0, veryUseful: 18.3, notUse: 52.0, rare: false },
                  { name: 'Waterfall Development Model', use: 45.1, veryUseful: 8.0, notUse: 54.9, rare: false },
                  { name: 'Canvas Business Model', use: 41.1, veryUseful: 9.1, notUse: 58.9, rare: false },
                  { name: 'North Star Metric', use: 40.0, veryUseful: 9.7, notUse: 60.0, rare: true },
                  { name: 'Design Sprint', use: 40.0, veryUseful: 9.1, notUse: 60.0, rare: true },
                  { name: 'Growth Hacking', use: 37.7, veryUseful: 8.0, notUse: 62.3, rare: true },
                  { name: 'RAT (Riskiest Assumption Test)', use: 36.6, veryUseful: 11.4, notUse: 63.4, rare: true },
                  { name: 'AIDA', use: 35.4, veryUseful: 5.1, notUse: 64.6, rare: true },
                  { name: 'Double Diamond', use: 33.7, veryUseful: 13.1, notUse: 66.3, rare: true },
                  { name: 'Blue Ocean', use: 33.1, veryUseful: 4.0, notUse: 66.9, rare: true },
                  { name: 'HEART', use: 30.9, veryUseful: 7.4, notUse: 69.1, rare: true },
                  { name: 'Presale Model', use: 30.3, veryUseful: 5.1, notUse: 69.7, rare: true },
                  { name: '4Ps Marketing Mix', use: 29.7, veryUseful: 5.1, notUse: 70.3, rare: true },
                  { name: 'RFM Analysis', use: 27.4, veryUseful: 6.3, notUse: 72.6, rare: true },
                  { name: 'SAFe (Scaled Agile Framework)', use: 26.9, veryUseful: 2.3, notUse: 73.1, rare: true },
                  { name: 'Opportunity Solution Tree', use: 24.6, veryUseful: 6.9, notUse: 75.4, rare: true },
                  { name: 'Gartner Magic Quadrant', use: 22.9, veryUseful: 3.4, notUse: 77.1, rare: true },
                  { name: 'LeSS (Large Scale Scrum)', use: 22.9, veryUseful: 1.1, notUse: 77.1, rare: true },
                  { name: 'Profitability', use: 22.3, veryUseful: 5.1, notUse: 77.7, rare: true },
                  { name: '2×2 Matrix', use: 22.3, veryUseful: 5.7, notUse: 77.7, rare: true },
                  { name: '7Ps Marketing Mix', use: 21.7, veryUseful: 3.4, notUse: 78.3, rare: true },
                  { name: 'Metric shoulder', use: 20.0, veryUseful: 5.1, notUse: 80.0, rare: true },
                  { name: 'ODI (Outcome-Driven Innovation)', use: 17.1, veryUseful: 3.4, notUse: 82.9, rare: true },
                  { name: 'Working backward', use: 16.0, veryUseful: 4.6, notUse: 84.0, rare: true },
                  { name: 'MECE', use: 15.4, veryUseful: 6.3, notUse: 84.6, rare: true },
                  { name: 'Hook Model', use: 15.4, veryUseful: 2.3, notUse: 84.6, rare: true },
                  { name: 'SEMAT', use: 9.1, veryUseful: 1.7, notUse: 90.9, rare: true },
                  { name: 'OODA Loops', use: 8.6, veryUseful: 1.7, notUse: 91.4, rare: true },
                ].map((framework, idx) => (
                  <div key={idx} className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors">
                    <div className="flex items-center justify-between flex-wrap gap-3">
                      <div className="flex items-center gap-3 flex-1 min-w-0">
                        <span className="text-base font-medium text-gray-900">{framework.name}</span>
                        {framework.rare && (
                          <span className="px-2 py-1 bg-gray-200 text-gray-600 rounded text-xs font-medium whitespace-nowrap">
                            Редко используют
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        <span className="text-gray-900">
                          <strong className="font-bold text-lg">{framework.use}%</strong> используют
                        </span>
                        <span className="text-gray-600">
                          {framework.veryUseful}% очень полезен
                        </span>
                        <span className="text-gray-500">
                          {framework.notUse}% не используют
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Инструменты / методики Section */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Инструменты / методики
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Оценка по шкале 0–3. Пустые ответы считаем за 0. Ниже — доля продактов, которые используют методику (1–3), считают её очень полезной (3) и не используют (0).
          </p>

          {/* Accordion */}
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <button
              onClick={() => setOpenMethodsAccordion(!openMethodsAccordion)}
              className="w-full px-8 py-6 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <span className="text-xl font-bold text-gray-900">Все методики</span>
              <i className={`ri-arrow-${openMethodsAccordion ? 'up' : 'down'}-s-line text-2xl text-gray-600 transition-transform`}></i>
            </button>
            
            {openMethodsAccordion && (
              <div className="px-8 pb-6 space-y-3">
                {[
                  { name: 'UX/UI testing', use: 52.6, veryUseful: 24.6, notUse: 47.4, rare: false },
                  { name: 'Unit-экономика', use: 49.7, veryUseful: 28.0, notUse: 50.3, rare: false },
                  { name: 'SWOT', use: 49.1, veryUseful: 14.9, notUse: 50.9, rare: false },
                  { name: 'Metric Analysis', use: 48.0, veryUseful: 19.4, notUse: 52.0, rare: false },
                  { name: 'RICE', use: 47.4, veryUseful: 22.9, notUse: 52.6, rare: false },
                  { name: 'SMART', use: 47.4, veryUseful: 22.3, notUse: 52.6, rare: false },
                  { name: 'Prototype', use: 46.9, veryUseful: 23.4, notUse: 53.1, rare: false },
                  { name: 'Mindmap', use: 45.1, veryUseful: 18.9, notUse: 54.9, rare: false },
                  { name: 'Feedback Collecting', use: 44.6, veryUseful: 22.9, notUse: 55.4, rare: false },
                  { name: 'Анализ рынка', use: 43.4, veryUseful: 18.3, notUse: 56.6, rare: false },
                  { name: 'OnePager', use: 40.0, veryUseful: 14.9, notUse: 60.0, rare: true },
                  { name: 'Составление карты воздействия', use: 40.0, veryUseful: 13.7, notUse: 60.0, rare: true },
                  { name: 'Метод 5 почему', use: 39.4, veryUseful: 18.3, notUse: 60.6, rare: true },
                  { name: 'Метод HADI', use: 38.3, veryUseful: 14.3, notUse: 61.7, rare: true },
                  { name: 'Product Vision Board', use: 37.7, veryUseful: 16.0, notUse: 62.3, rare: true },
                  { name: 'MoSCoW', use: 36.6, veryUseful: 9.7, notUse: 63.4, rare: true },
                  { name: 'ICE', use: 34.9, veryUseful: 16.0, notUse: 65.1, rare: true },
                  { name: 'KANO', use: 33.7, veryUseful: 11.4, notUse: 66.3, rare: true },
                  { name: 'ABC Analysis', use: 31.4, veryUseful: 11.4, notUse: 68.6, rare: true },
                  { name: 'Top-down / Bottom-up', use: 30.3, veryUseful: 8.6, notUse: 69.7, rare: true },
                  { name: 'Сервис Blueprint', use: 27.4, veryUseful: 6.3, notUse: 72.6, rare: true },
                  { name: 'Графики KPI', use: 26.9, veryUseful: 11.4, notUse: 73.1, rare: true },
                  { name: 'Оценка сегмента', use: 25.1, veryUseful: 8.6, notUse: 74.9, rare: true },
                  { name: 'Оценка функций', use: 24.0, veryUseful: 8.6, notUse: 76.0, rare: true },
                  { name: 'Стратегия продвижения', use: 23.4, veryUseful: 8.6, notUse: 76.6, rare: true },
                  { name: 'Функциональные требования', use: 22.3, veryUseful: 8.6, notUse: 77.7, rare: true },
                  { name: 'Дерево продуктов', use: 21.7, veryUseful: 6.9, notUse: 78.3, rare: true },
                  { name: 'Покерное планирование', use: 20.6, veryUseful: 5.1, notUse: 79.4, rare: true },
                  { name: 'Матрица RACI', use: 18.9, veryUseful: 5.1, notUse: 81.1, rare: true },
                  { name: 'Метод «Шесть шляп мышления»', use: 18.9, veryUseful: 4.6, notUse: 81.1, rare: true },
                  { name: 'UX-очки', use: 17.1, veryUseful: 1.1, notUse: 82.9, rare: true },
                  { name: 'TechRadar', use: 13.1, veryUseful: 1.7, notUse: 86.9, rare: true },
                  { name: 'Купить функцию', use: 12.6, veryUseful: 0.6, notUse: 87.4, rare: true },
                  { name: 'GIST', use: 12.6, veryUseful: 2.9, notUse: 87.4, rare: true },
                  { name: 'QFD (развертывание функций качества)', use: 10.9, veryUseful: 1.7, notUse: 89.1, rare: true },
                  { name: 'Метод KJ', use: 5.1, veryUseful: 0.6, notUse: 94.9, rare: true },
                ].map((method, idx) => (
                  <div key={idx} className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors">
                    <div className="flex items-center justify-between flex-wrap gap-3">
                      <div className="flex items-center gap-3 flex-1 min-w-0">
                        <span className="text-base font-medium text-gray-900">{method.name}</span>
                        {method.rare && (
                          <span className="px-2 py-1 bg-gray-200 text-gray-600 rounded text-xs font-medium whitespace-nowrap">
                            Редко используют
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        <span className="text-gray-900">
                          <strong className="font-bold text-lg">{method.use}%</strong> используют
                        </span>
                        <span className="text-gray-600">
                          {method.veryUseful}% очень полезен
                        </span>
                        <span className="text-gray-500">
                          {method.notUse}% не используют
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Сервисы / Софт Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Сервисы / Софт
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Оценка по шкале 0–3. Пустые ответы считаем как 0. Ниже — доля продактов, которые используют сервис (1–3), используют регулярно (3), и не используют (0).
          </p>

          {/* Accordion */}
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <button
              onClick={() => setOpenServicesAccordion(!openServicesAccordion)}
              className="w-full px-8 py-6 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <span className="text-xl font-bold text-gray-900">Все сервисы</span>
              <i className={`ri-arrow-${openServicesAccordion ? 'up' : 'down'}-s-line text-2xl text-gray-600 transition-transform`}></i>
            </button>
            
            {openServicesAccordion && (
              <div className="px-8 pb-6 space-y-3">
                {[
                  { name: 'Figma', use: 55.4, regular: 37.7, notUse: 44.6, rare: false },
                  { name: 'ChatGPT', use: 54.3, regular: 40.6, notUse: 45.7, rare: false },
                  { name: 'Miro', use: 54.3, regular: 33.7, notUse: 45.7, rare: false },
                  { name: 'Google Workspace (Docs, Sheets, Slides)', use: 53.1, regular: 38.3, notUse: 46.9, rare: false },
                  { name: 'Zoom', use: 52.6, regular: 22.3, notUse: 47.4, rare: false },
                  { name: 'Jira', use: 50.3, regular: 33.7, notUse: 49.7, rare: false },
                  { name: 'Notion', use: 48.0, regular: 20.0, notUse: 52.0, rare: false },
                  { name: 'Google Analytics', use: 45.7, regular: 16.6, notUse: 54.3, rare: false },
                  { name: 'Яндекс.Метрика', use: 44.6, regular: 18.9, notUse: 55.4, rare: false },
                  { name: 'Power BI', use: 39.4, regular: 12.6, notUse: 60.6, rare: true },
                  { name: 'Slack', use: 37.1, regular: 17.1, notUse: 62.9, rare: true },
                  { name: 'Tableau', use: 34.9, regular: 9.7, notUse: 65.1, rare: true },
                  { name: 'Trello', use: 34.3, regular: 10.3, notUse: 65.7, rare: true },
                  { name: 'Amplitude', use: 33.7, regular: 10.3, notUse: 66.3, rare: true },
                  { name: 'Asana', use: 31.4, regular: 6.9, notUse: 68.6, rare: true },
                  { name: 'ClickUp', use: 29.7, regular: 7.4, notUse: 70.3, rare: true },
                  { name: 'Kaiten', use: 25.1, regular: 6.3, notUse: 74.9, rare: true },
                  { name: 'Calendly', use: 22.3, regular: 5.7, notUse: 77.7, rare: true },
                  { name: 'App Metrica', use: 22.3, regular: 6.9, notUse: 77.7, rare: true },
                  { name: 'Lucidchart', use: 13.1, regular: 2.3, notUse: 86.9, rare: true },
                  { name: 'Mixpanel', use: 13.1, regular: 2.9, notUse: 86.9, rare: true },
                  { name: 'Weeek', use: 13.1, regular: 2.9, notUse: 86.9, rare: true },
                  { name: 'Tilda', use: 11.4, regular: 3.4, notUse: 88.6, rare: true },
                  { name: 'Grafana', use: 10.9, regular: 2.3, notUse: 89.1, rare: true },
                  { name: 'Airtable', use: 10.9, regular: 2.3, notUse: 89.1, rare: true },
                  { name: 'Integromat (Make)', use: 9.7, regular: 2.3, notUse: 90.3, rare: true },
                  { name: 'Webflow', use: 8.6, regular: 2.3, notUse: 91.4, rare: true },
                  { name: 'Zapier', use: 8.0, regular: 1.7, notUse: 92.0, rare: true },
                  { name: 'Bubble', use: 8.0, regular: 1.7, notUse: 92.0, rare: true },
                  { name: 'Optimizely', use: 8.0, regular: 2.9, notUse: 92.0, rare: true },
                  { name: 'UserTesting', use: 8.0, regular: 2.3, notUse: 92.0, rare: true },
                  { name: 'Framer', use: 6.9, regular: 1.7, notUse: 93.1, rare: true },
                  { name: 'Marvel', use: 6.9, regular: 1.7, notUse: 93.1, rare: true },
                  { name: 'UsabilityHub', use: 6.9, regular: 0.6, notUse: 93.1, rare: true },
                  { name: 'Glide', use: 6.3, regular: 1.7, notUse: 93.7, rare: true },
                  { name: 'Maze', use: 5.7, regular: 0.6, notUse: 94.3, rare: true },
                  { name: 'UserZoom', use: 5.7, regular: 1.7, notUse: 94.3, rare: true },
                  { name: 'Gramax', use: 5.7, regular: 0.0, notUse: 94.3, rare: true },
                  { name: 'Яндекс.Взгляд', use: 5.7, regular: 1.7, notUse: 94.3, rare: true },
                  { name: 'Principle', use: 5.1, regular: 1.1, notUse: 94.9, rare: true },
                  { name: 'Quick test', use: 5.1, regular: 0.0, notUse: 94.9, rare: true },
                  { name: 'Voiceflow', use: 5.1, regular: 0.0, notUse: 94.9, rare: true },
                  { name: 'Adalo', use: 4.6, regular: 0.6, notUse: 95.4, rare: true },
                  { name: 'Side-by-side', use: 3.4, regular: 0.0, notUse: 96.6, rare: true },
                  { name: 'Lookback', use: 2.9, regular: 0.6, notUse: 97.1, rare: true },
                ].map((service, idx) => (
                  <div key={idx} className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors">
                    <div className="flex items-center justify-between flex-wrap gap-3">
                      <div className="flex items-center gap-3 flex-1 min-w-0">
                        <span className="text-base font-medium text-gray-900">{service.name}</span>
                        {service.rare && (
                          <span className="px-2 py-1 bg-gray-200 text-gray-600 rounded text-xs font-medium whitespace-nowrap">
                            Редко используют
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        <span className="text-gray-900">
                          <strong className="font-bold text-lg">{service.use}%</strong> используют
                        </span>
                        <span className="text-gray-600">
                          {service.regular}% регулярно
                        </span>
                        <span className="text-gray-500">
                          {service.notUse}% не используют
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Cargo Cult Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-start space-x-6 mb-12">
            <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-alert-line text-3xl text-amber-600"></i>
            </div>
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Карго-культ инструментов
              </h2>
              <p className="text-xl text-gray-600">
                Где продакты чаще всего ошибаются
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-gray-50 rounded-2xl p-8 border-l-4 border-amber-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Переносят инструмент из проекта в проект
              </h3>
              <p className="text-gray-700 leading-relaxed">
                «В прошлой компании мы использовали X, значит и здесь будем». Контекст другой, команда другая, задачи другие — а инструмент тот же.
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border-l-4 border-amber-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Используют шаблон вместо мышления
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Скачали шаблон RICE, заполнили циферки — и думают, что приоритизировали. Но формула не заменяет понимание контекста.
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border-l-4 border-amber-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Внедряют, потому что «так принято»
              </h3>
              <p className="text-gray-700 leading-relaxed">
                «Все используют OKR, значит и нам надо». Но если цели и так понятны, зачем добавлять процесс ради процесса?
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border-l-4 border-amber-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Собирают «стек мечты» вместо решения задач
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Amplitude + Mixpanel + Hotjar + FullStory. Все крутое, все нужное. Но кто это будет анализировать? И зачем дублировать функции?
              </p>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-br from-slate-700 to-slate-600 rounded-3xl p-10 text-white">
            <p className="text-2xl font-bold leading-relaxed">
              Если инструмент не экономит время и не помогает принять решение — он мешает.
            </p>
          </div>
        </div>
      </section>

      {/* Limitations Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
            Что важно учитывать
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-line text-white"></i>
              </div>
              <p>
                <strong>Это срез, а не стандарт.</strong> Популярность инструмента не означает, что он подойдёт именно вам.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-line text-white"></i>
              </div>
              <p>
                <strong>Рынок меняется.</strong> Через полгода картина может быть другой. Новые инструменты появляются, старые уходят.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-line text-white"></i>
              </div>
              <p>
                <strong>Инструменты эволюционируют.</strong> То, что было неудобно год назад, могло стать лучше. И наоборот.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-line text-white"></i>
              </div>
              <p>
                <strong>Выводы актуальны в контексте.</strong> Это исследование отражает реальность конца 2024 года.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final Conclusion Section */}
      <section className="py-32 bg-gradient-to-br from-slate-700 to-slate-600 text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="mb-8">
            <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-sm font-medium">
              Итого
            </span>
          </div>
          <h2 className="text-4xl lg:text-6xl font-bold mb-12 leading-tight">
            Если совсем коротко
          </h2>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-12 lg:p-16">
            <p className="text-2xl lg:text-4xl font-bold leading-relaxed">
              Инструменты — это расходный материал.
            </p>
            <p className="text-2xl lg:text-4xl font-bold leading-relaxed mt-6">
              Ценность — в решённой задаче и высвободившемся времени продакта.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Это исследование — часть проекта «Инструменты продакта»
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed">
            Я собираю инструменты, шаблоны, приёмы и способы их использования — без лишних мучений.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="https://jaknaf.readdy.co"
              className="px-8 py-4 bg-[#EE9B00] text-white rounded-lg font-medium hover:bg-[#D88A00] transition-all whitespace-nowrap cursor-pointer inline-block"
            >
              Перейти к базе инструментов
            </a>
            <button className="px-8 py-4 bg-gray-100 text-gray-900 rounded-lg font-medium hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
              Подписаться на обновления
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/a422443b07c5ef04b420db188867b9ad/ce6fd3da735f6be630e7bf30dfef3790.png"
                  alt="PM Tools Logo"
                  className="h-10 w-auto"
                />
                <span className="text-xl font-bold">Инструменты продакта</span>
              </div>
              <p className="text-gray-400 mb-6 leading-relaxed">
                Кураторская коллекция лучших инструментов для продакт-менеджеров. Экономьте время на поиске и фокусируйтесь на создании продуктов.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#EE9B00] rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#EE9B00] rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-twitter-x-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#EE9B00] rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-mail-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Навигация</h3>
              <ul className="space-y-3">
                <li>
                  <a href="https://jaknaf.readdy.co" className="text-gray-400 hover:text-[#EE9B00] transition-colors cursor-pointer">
                    Главная
                  </a>
                </li>
                <li>
                  <a href="/research" className="text-gray-400 hover:text-[#EE9B00] transition-colors cursor-pointer">
                    Исследование
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Контакты</h3>
              <ul className="space-y-3">
                <li className="text-gray-400">info@pmtools.ru</li>
                <li className="text-gray-400">+7 (999) 123-45-67</li>
                <li className="text-gray-400">Москва, Россия</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Инструменты продакта. Все права защищены.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-[#EE9B00] text-sm transition-colors cursor-pointer">
                Политика конфиденциальности
              </a>
              <a href="#" className="text-gray-400 hover:text-[#EE9B00] text-sm transition-colors cursor-pointer">
                Условия использования
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                className="text-gray-400 hover:text-[#EE9B00] text-sm transition-colors cursor-pointer"
                target="_blank"
                rel="noopener noreferrer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
